import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinStandbyCompletedSubHeaderComponent } from './checkin-standby-completed-sub-header.component';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [CheckinStandbyCompletedSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [CheckinStandbyCompletedSubHeaderComponent],
})
export class CheckinStandbyCompletedSubHeaderModule {}
